<template>
  <v-app>
    <v-content>
      <v-container fluid fill-height>
        <v-layout justify-center align-top>
          This is a public page, which can be access without authentication
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
export default {
  name: 'Public'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/public/Public.vue